import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const AthletaSVG = (
  <svg fill="none" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M13.283 6.804a6.642 6.642 0 10-2.722 5.203l3.694 3.694.028.027a1 1 0 001.39 0l.028-.027.016-.016.011-.012a1 1 0 000-1.39l-.027-.027-3.695-3.695a6.61 6.61 0 001.277-3.757zM2 6.642a4.642 4.642 0 007.832 3.373 1.006 1.006 0 01.088-.095l.028-.028.067-.06A4.642 4.642 0 102 6.642z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);
const BananaRepublicSVG = (
  <svg fill="none" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9874 11.1768l5.6569 5.6568-1.0607 1.0607-5.65683-5.6569 1.06063-1.0606z"
      fill="#000"
    />
    <path
      d="M7 .25C3.27208.25.25 3.27208.25 7c0 3.7279 3.02208 6.75 6.75 6.75 3.7279 0 6.75-3.0221 6.75-6.75C13.75 3.27208 10.7279.25 7 .25zm0 1.5c2.8995 0 5.25 2.35051 5.25 5.25 0 2.8995-2.3505 5.25-5.25 5.25-2.89949 0-5.25-2.3505-5.25-5.25 0-2.89949 2.35051-5.25 5.25-5.25z"
      fill="#000"
    />
  </svg>
);
const GapSVG = (
  <svg fill="none" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9874 11.1768l5.6569 5.6568-1.0607 1.0607-5.65684-5.6569 1.06064-1.0606z"
      fill="#000"
    />
    <path
      d="M7 .25C3.27208.25.25 3.27208.25 7c0 3.7279 3.02208 6.75 6.75 6.75 3.7279 0 6.75-3.0221 6.75-6.75C13.75 3.27208 10.7279.25 7 .25zm0 1.5c2.89949 0 5.25 2.35051 5.25 5.25S9.89949 12.25 7 12.25 1.75 9.89949 1.75 7 4.10051 1.75 7 1.75z"
      fill="#000"
    />
  </svg>
);
const OldNavySVG = (
  <svg fill="none" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9874 11.1768l5.6569 5.6568-1.0607 1.0607-5.65684-5.6569 1.06064-1.0606z"
      fill="#043863"
    />
    <path
      d="M7 .25C3.27208.25.25 3.27208.25 7c0 3.7279 3.02208 6.75 6.75 6.75 3.7279 0 6.75-3.0221 6.75-6.75C13.75 3.27208 10.7279.25 7 .25zm0 1.5c2.8995 0 5.25 2.35051 5.25 5.25 0 2.8995-2.3505 5.25-5.25 5.25-2.89949 0-5.25-2.3505-5.25-5.25 0-2.89949 2.35051-5.25 5.25-5.25z"
      fill="#043863"
    />
  </svg>
);

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M11.6774 11.8667C12.9549 10.6385 13.75 8.91212 13.75 7 13.75 3.27208 10.7279.25 7 .25 3.27208.25.25 3.27208.25 7c0 3.7279 3.02208 6.75 6.75 6.75 1.27157 0 2.46103-.3516 3.4764-.9629l5.1072 5.1072 1.0607-1.0607-4.9669-4.9669zM7 12.25c-2.89949 0-5.25-2.3505-5.25-5.25 0-2.89949 2.35051-5.25 5.25-5.25 2.8995 0 5.25 2.35051 5.25 5.25 0 2.8995-2.3505 5.25-5.25 5.25z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: AthletaSVG,
  [Brands.BananaRepublic]: BananaRepublicSVG,
  [Brands.BananaRepublicFactoryStore]: BananaRepublicSVG,
  [Brands.Gap]: GapSVG,
  [Brands.GapFactoryStore]: GapSVG,
  [Brands.OldNavy]: OldNavySVG,
  crossBrand: CrossBrandSVG,
};

export const MagnifierIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
